import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Header.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Header({ icon, title, children, style }) {
  const { Header } = Styles;
  return (
    <div className={Header} style={{ ...style }}>
      <div>
        <FontAwesomeIcon icon={icon} />
        <p>{title}</p>
      </div>
      <div>{children}</div>
    </div>
  );
}

Header.defaultProps = {
  style: {},
  children: null,
};

Header.propTypes = {
  icon: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  style: PropTypes.object,
};
